var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/core-js/library/modules/_html.js
// module id = 1999
// module chunks = 1